import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NexusAlertComponent } from './icon/nexus-alert/nexus-alert.component';
import { ModalCargaComponent } from './icon/modal-carga/modal-carga.component';
import { ImgEnvioComponent } from './icon/img-envio/img-envio.component';
import { ProgressComponent } from './icon/progress/progress.component';
import { IconsModule } from '../icons/icons.module';
import { IconBuildingComponent } from './icon/icon-building/icon-building.component';


@NgModule({
  declarations: [
    NexusAlertComponent,
    ModalCargaComponent,
    ImgEnvioComponent,
    ProgressComponent,
    IconBuildingComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
  ],
  exports: [
    ModalCargaComponent,
    NexusAlertComponent,
    ImgEnvioComponent,
    ProgressComponent, 
    IconBuildingComponent
  ]
})
export class UtilModule { }
